module.exports = __webpack_public_path__ + "static/media/greyPower.0c77f752.svg";